type SwitchFieldProps = {
	label: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
	id?: string;
	/** Keeps the label for screen readers only, for use in tight layouts. */
	hideLabel?: boolean;
};

export function SwitchField({
	label,
	checked,
	onChange,
	id,
	hideLabel = false,
}: SwitchFieldProps) {
	const switchId = id ?? label.toLowerCase().replace(/[^a-z0-9]+/g, "-");

	return (
		<label className="pf-switch" htmlFor={switchId}>
			<input
				id={switchId}
				className="pf-switch__input"
				type="checkbox"
				role="switch"
				checked={checked}
				onChange={(event) => onChange(event.target.checked)}
			/>
			<span
				className={`pf-switch__label${hideLabel ? " pf-switch__label--hidden" : ""}`}
			>
				{label}
			</span>
			<span className="pf-switch__track">
				<span className="pf-switch__thumb" />
			</span>
		</label>
	);
}
